<template>
    <scroll-pull-down class="screen-height" :onScrollTop="'0.88rem'" :onScrollBackgroundColor="'#fff'" :onAreMore="false">
        <div class="page-head box-shadow" slot="header">
            <div class="page-head-back" @click="goBack">
                <span class="icon"></span>
            </div>
            <div class="page-head-menu-right" @click="options.SideMenu = true"></div>
        </div>
        <div class="DiamondList-main" slot="container">
            <iframe :src="src" frameborder="0" style="width: 100%; height: 100%;"></iframe>
        </div>
        <SideMenu :visible="options.SideMenu" slot="headerMenu" @onComplete="onSideMenu"></SideMenu>
    </scroll-pull-down>
</template>
<script>
    import Core from '@/until/core'
    import ScrollPullDown from '@/public/ScrollPullDown'
    import SideMenu from '@/public/SideMenu'
    export default {
        name: 'DiaWeb',
        data () {
            return {
                options: {
                    SideMenu: false
                }
            }
        },
        components: {
            ScrollPullDown,
            SideMenu
        },
        watch: {},
        computed: {
            src () {
                return 'https://www.gia.edu/report-check?reportno=' + this.$route.query.cert + '&s=' + Date.now()
            }
        },
        filters: {},
        methods: {
            goBack () {
                Core.goBack()
            },
            onSideMenu (state) {
                this.options.SideMenu = false
            }
        },
        mounted () {
            this.$nextTick(() => {
                console.log(document.body.clientHeight)
            })
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .DiamondList-main{ width: 100%; height: 100%; }
</style>



// WEBPACK FOOTER //
// src/components/DiaWeb.vue